<template>
  <div class="upload-excel">
    <span
      class="count-uploaded-items"
      :class="{ 'count-uploaded-items-facture': hiddenContent }"
      v-if="showCount && count != null"
      @click="
        count = null;
        $emit('searchWithNumDossier', null);
      "
      >{{ count }}</span
    >
    <div
      class="chargement chargement-loading-icon loader-uploaded-items"
      :class="{ 'loader-circle': hiddenContent }"
      v-if="loader"
    >
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div
      class="container"
      :class="{ 'hidden-container-style': hiddenContent }"
      @click="
        count = null;
        $emit('searchWithNumDossier', null);
      "
    >
      <div
        class="file-wrapper"
        :class="{
          'succes-file-excel': value != null,
          'hidden-file-style': hiddenContent
        }"
      >
        <input
          type="file"
          name="file-input"
          id="uploadInput"
          @change="handleFileInput"
          :disabled="showCount && loader"
        />

        <div class="upload_label" v-if="!hiddenContent">
          <font-awesome-icon icon="cloud-upload-alt" />
        </div>
        <v-tooltip bottom color="#311B92" v-else>
          <template v-slot:activator="{ on }">
            <div class="block-icon mr-2" v-on="on">
              <IconClouduploadAlt></IconClouduploadAlt>
            </div>
          </template>
          <span>Upload facture</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props: {
    value: { required: true },
    fetchFuntion: { resuired: false },
    showCount: { default: false },
    hiddenContent: { required: false }
  },
  data() {
    return { file: null, count: null, loader: false };
  },
  methods: {
    ...mapActions(['uploadFileExcelNumDossier']),
    async handleFileInput(e) {
      let files = e.target.files;
      files = e.target.files;
      if (!files) return;
      [...files].forEach(f => {
        this.file = f;
      });
      document.getElementById('uploadInput').value = '';
      if (!this.fetchFuntion) {
        const response = await this.uploadFileExcelNumDossier(this.file);
        if (response.succes) {
          this.$emit('searchWithNumDossier', response.data);
        }
      } else {
        this.loader = true;
        const response = await this.fetchFuntion(this.file);
        if (response.succes) {
          this.count = response.data.length;
          this.$emit('searchWithNumDossier', response.data);
        } else {
          this.$alert('', response.error, 'erreur');
        }
        this.loader = false;
      }
    }
  },
  components: {
    IconClouduploadAlt: () => import('@/assets/img/IconClouduploadAlt.vue')
  }
};
</script>

<style lang="scss" scoped>
.upload-excel {
  z-index: 0 ;
  position: relative;
  .container {
    &.hidden-container-style {
      height: unset;
      width: unset;
      padding: 0px;
    }
    height: 30px;
    width: 59px;
    .file-wrapper {
      cursor: pointer;
      &.hidden-file-style {
        padding: 0px;
        border-radius: 0px;
        border: 0px;
        background-color: transparent;
      }
      text-align: center;
      width: 100%;
      height: 100%;
      vertical-align: middle;
      position: relative;
      overflow: hidden;
      border: 1px solid #4d4bac;
      background-color: #4d4bac;
      color: #fff;
      border-radius: 16px;
      box-shadow: 1px 2px 5px 5px #f5f5f5;
      padding: 3px;
      input {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
        cursor: pointer;
        z-index: 5;
      }
      .display {
        display: none;
      }
      .upload_label {
        font-size: 16px;
        position: relative;
      }
    }
    .succes-file-excel {
      border: 1px solid #6fc76557;
      background-color: #0e5e069c;
      font-size: 9px;
    }
  }
  .loader-uploaded-items {
    &.loader-circle {
      position: absolute;
      z-index: 100;
      right: 12px;
      top: 4px;
      color: #704ad1;
    }
    position: absolute;
    z-index: 100;
    right: 18px;
    top: 3px;
    color: white;
  }
  .count-uploaded-items {
    &.count-uploaded-items-facture {
      position: absolute;
      right: 17px;
      background: #704ad1;
      border-radius: 50px;
      font-size: 10px;
      line-height: 13px;
      color: white;
      padding: 0px 3px;
      top: -8px;
      z-index: 100;
      cursor: pointer;
    }
    position: absolute;
    right: 12px;
    background: #f7c04a;
    border-radius: 50px;
    font-size: 10px;
    line-height: 13px;
    color: white;
    padding: 0px 3px;
    top: -4px;
    z-index: 100;
    cursor: pointer;
  }
}
</style>
